import { useMemo } from "react"
import { Card, CardContent, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { CostCriticalitySummaryItem } from "./cost-criticality-summary-item"

const CRITICALITY_ORDER = ["Red", "Pink", "Amber", "Green"]

export function CostCriticalityCard({ costResult, currencySymbol }) {
    const items = useMemo(getItems, [costResult])

    return (
        <Card sx={{ flex: 1.3 }}>
            <CardContent sx={{ p: 3 }}>
                <Stack spacing={2.5} sx={{ height: "100%" }}>
                    <Typography variant="h6" sx={{ fontSize: "18px !important" }}>
                        Criticality
                    </Typography>
                    <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ flex: 1 }}>
                        <Repeat list={items} item={<CostCriticalitySummaryItem currencySymbol={currencySymbol} />} />
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    function getItems() {
        const breakdown = costResult?.criticalityBreakdown || []
        return CRITICALITY_ORDER.map((classification) => {
            const entry = breakdown.find(matchesClassification(classification))
            return {
                classification,
                totalCost: entry?.totalCost || 0,
                taskCount: entry?.taskCount || 0,
                percentage: entry?.percentage || 0,
            }
        })
    }

    function matchesClassification(classification) {
        return function isMatch(b) {
            return b.classification === classification
        }
    }
}
